
/**
 * Internal dependencies
 */
import { makeLayout, render } from 'lib/controller';
import { login } from './controller';

export default (router) => {
    router(`/login`, login, makeLayout, render);
};
